import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/selectArrow.gif'


const _hoisted_1 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_2 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_3 = { class: "layerMain" }
const _hoisted_4 = { class: "layerMainText" }
const _hoisted_5 = { class: "bold blue" }
const _hoisted_6 = { class: "bold red" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "bold red" }
const _hoisted_9 = { class: "layerBtnArea" }
const _hoisted_10 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_11 = { class: "layerMain" }
const _hoisted_12 = { class: "layerMainText" }
const _hoisted_13 = { class: "bold red" }
const _hoisted_14 = { class: "bold red" }
const _hoisted_15 = { class: "bold red" }
const _hoisted_16 = { class: "bold blue" }
const _hoisted_17 = { class: "bold red" }
const _hoisted_18 = { class: "layerBtnArea" }
const _hoisted_19 = {
  class: "layer categoryReName",
  style: {"position":"fixed"}
}
const _hoisted_20 = { class: "layerMain" }
const _hoisted_21 = { class: "layerMainText" }
const _hoisted_22 = { class: "textinputLine" }
const _hoisted_23 = { class: "layerBtnArea" }
const _hoisted_24 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_25 = { class: "layerMain" }
const _hoisted_26 = { class: "layerMainText" }
const _hoisted_27 = { class: "bold red" }
const _hoisted_28 = { class: "mgB10" }
const _hoisted_29 = { class: "layerBtnArea" }
const _hoisted_30 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_31 = { class: "layerBtnArea" }
const _hoisted_32 = {
  class: "layer deletAlt",
  style: {"position":"fixed"}
}
const _hoisted_33 = { class: "layerBtnArea" }
const _hoisted_34 = { class: "box" }
const _hoisted_35 = {
  class: "pageTitleTab left",
  style: {"margin-bottom":"20px"}
}
const _hoisted_36 = { class: "hangulAlign" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "searchArea right" }
const _hoisted_39 = {
  class: "contDetailViewSelectOutputText",
  style: {}
}
const _hoisted_40 = { class: "groupEditBox" }
const _hoisted_41 = { class: "groupEditBoxBar" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "left mgR25" }
const _hoisted_44 = ["onUpdate:modelValue", "onChange"]
const _hoisted_45 = { class: "groupName left bold" }
const _hoisted_46 = {
  key: 0,
  class: "right"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "right",
  style: {"width":"690px","font-size":"16px"}
}
const _hoisted_54 = { class: "right" }
const _hoisted_55 = { class: "groupNameBox" }
const _hoisted_56 = { class: "mgR25" }
const _hoisted_57 = ["value", "onUpdate:modelValue"]
const _hoisted_58 = { class: "left" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "right" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "groupEditBox" }
const _hoisted_65 = {
  class: "left",
  style: {"margin-top":"2px"}
}
const _hoisted_66 = { class: "left mgR25" }
const _hoisted_67 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustSelectFilter = _resolveComponent("CustSelectFilter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[27] || (_cache[27] = [
      _createStaticVNode("<div class=\"layerTitle\">알림</div><div class=\"layerMain\"><div class=\"layerMainText\"> 이동 되었습니다. </div></div><div class=\"layerBtnArea\"><button class=\"blueBtn\">확인</button></div>", 3)
    ]))], 512), [
      [_vShow, $data.ui.mesg_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, "'" + _toDisplayString($data.ui.group_proc.group_nm) + "'", 1),
          _cache[28] || (_cache[28] = _createTextVNode("그룹에 있는 ", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString($data.ui.group_proc.cnt), 1),
          _cache[29] || (_cache[29] = _createTextVNode("개의 연락처를 ", -1)),
          _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
          _withDirectives(_createElementVNode("select", {
            class: "selectBox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.ui.group_proc.new_group_no) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ui.group_proc.group_info, (r) => {
              return (_openBlock(), _createElementBlock("option", {
                value: r.GROUP_NO
              }, _toDisplayString(r.GROUP_NM), 9, _hoisted_7))
            }), 256))
          ], 512), [
            [_vModelSelect, $data.ui.group_proc.new_group_no]
          ]),
          _cache[31] || (_cache[31] = _createTextVNode(" 그룹으로 ", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString($data.ui.group_proc.txt), 1),
          _cache[32] || (_cache[32] = _createTextVNode(" 합니다. ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.group_custs_exec()))
        }, "확인"),
        _cache[33] || (_cache[33] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.move_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _cache[48] || (_cache[48] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("div", null, [
            _cache[35] || (_cache[35] = _createTextVNode(" 선택한 ", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString($data.ui.group_proc.cnt), 1),
            _cache[36] || (_cache[36] = _createTextVNode("개의 연락처를 ", -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString($data.ui.group_proc.txt), 1),
            _cache[37] || (_cache[37] = _createTextVNode(" 합니다. ", -1))
          ], 512), [
            [_vShow, $data.ui.group_proc.cmd === 'del']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _cache[38] || (_cache[38] = _createTextVNode(" 선택한 ", -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString($data.ui.group_proc.cnt), 1),
            _cache[39] || (_cache[39] = _createTextVNode("개의 연락처를 ", -1)),
            _createElementVNode("span", _hoisted_16, "'" + _toDisplayString($data.ui.group_proc.group_nm) + "' ", 1),
            _cache[40] || (_cache[40] = _createTextVNode("그룹에서 ", -1)),
            _createElementVNode("span", _hoisted_17, _toDisplayString($data.ui.group_proc.txt), 1),
            _cache[41] || (_cache[41] = _createTextVNode(" 합니다. ", -1)),
            _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
            _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
            _cache[44] || (_cache[44] = _createTextVNode(" 제외된 연락처에 지정된 그룹이 하나도 없는 경우", -1)),
            _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
            _cache[46] || (_cache[46] = _createTextVNode(" 미지정 그룹으로 이동합니다. ", -1))
          ], 512), [
            [_vShow, $data.ui.group_proc.cmd === 'excl']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.group_custs_exec()))
        }, "확인"),
        _cache[47] || (_cache[47] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.excl_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "layerTitle" }, "그룹명 수정", -1)),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[49] || (_cache[49] = _createTextVNode(" 수정하실 그룹명을 입력해주세요", -1)),
          _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
          _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "그룹명을 입력해주세요",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.ui.edit_group_nm) = $event)),
              style: {"width":"245px"},
              prefix: "edit_group_nm",
              maxlength: "50",
              minlength: "2"
            }, null, 512), [
              [_vModelText, $data.ui.edit_group_nm]
            ])
          ]),
          _cache[52] || (_cache[52] = _createTextVNode(" ※ 그룹명은 2글자이상만 가능합니다. ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.group_update()))
        }, "저장"),
        _cache[53] || (_cache[53] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.edit_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_24, [
      _cache[59] || (_cache[59] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, " 선택하신 그룹 [" + _toDisplayString($data.ui.edit_group_nm) + "] 을 삭제 ", 1),
          _cache[55] || (_cache[55] = _createTextVNode("하시겠습니까? ", -1))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.api.edit.DEL_TYPE) = $event)),
              value: 1
            }, null, 512), [
              [_vModelRadio, $data.api.edit.DEL_TYPE]
            ]),
            _cache[56] || (_cache[56] = _createTextVNode("그룹만 삭제 (연락처는 그대로 유지)", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.api.edit.DEL_TYPE) = $event)),
              value: 2
            }, null, 512), [
              [_vModelRadio, $data.api.edit.DEL_TYPE]
            ]),
            _cache[57] || (_cache[57] = _createTextVNode("그룹 및 그룹의 구성원까지 모두 삭제", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.group_del()))
        }, "확인"),
        _cache[58] || (_cache[58] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.del_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_30, [
      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "layerMain" }, [
        _createElementVNode("div", { class: "layerMainText" }, [
          _createElementVNode("span", { class: "bold red" }, " 미지정 그룹에 있는 연락처를 삭제 하시겠습니까? ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.not_group_del()))
        }, "확인"),
        _cache[60] || (_cache[60] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.not_group_del_layer]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_32, [
      _cache[64] || (_cache[64] = _createStaticVNode("<div class=\"layerTitle\">그룹 초기화</div><div class=\"layerMain\"><div class=\"layerMainText\"><span class=\"bold red\">전체 그룹을 초기화 하시겠습니까?</span><br><br><span class=\"bold\">등록하신 모든 그룹이 삭제 됩니다. 반드시 확인 후 진행하시기 바랍니다. </span><br><br><span class=\"bold blue\">모든 그룹이 삭제되고 모든 연락처는 그룹 미지정으로 이동됩니다.</span></div></div>", 2)),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", {
          class: "redBtn",
          onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.group_init()))
        }, "확인"),
        _cache[63] || (_cache[63] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.all_layer_off()))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.group_init_layer]
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '0' }]),
          onClick: _cache[16] || (_cache[16] = ($event: any) => {$options.select_assign('BLVR_CATE', '0');})
        }, "전체", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '1' }]),
          onClick: _cache[17] || (_cache[17] = ($event: any) => {$options.select_assign('BLVR_CATE', '1');})
        }, "상생방송", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '4' }]),
          onClick: _cache[18] || (_cache[18] = ($event: any) => {$options.select_assign('BLVR_CATE', '4');})
        }, "역사광복", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '9' }]),
          onClick: _cache[19] || (_cache[19] = ($event: any) => {$options.select_assign('BLVR_CATE', '9');})
        }, "미지정", 2)
      ]),
      _createElementVNode("div", {
        class: "left",
        style: {"position":"relative"},
        onClick: _cache[20] || (_cache[20] = ($event: any) => {$options.select_layerView();})
      }, [...(_cache[65] || (_cache[65] = [
        _createElementVNode("div", { class: "selectListBox jsdPosition2" }, [
          _createTextVNode(" 상세조건 "),
          _createElementVNode("div", { class: "selectArrowimg right" }, [
            _createElementVNode("img", { src: _imports_0 })
          ])
        ], -1)
      ]))]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.han_key_list, (r) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass({ select: $data.api.list.HAN_KEY === r.value}),
              onClick: ($event: any) => {$options.select_assign('ㄱㄴㄷ', r);}
            }, [
              _createElementVNode("span", null, _toDisplayString(r.title), 1)
            ], 10, _hoisted_37))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search",
          maxlength: "20",
          placeholder: "이름 휴대폰 번호 검색",
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($data.api.list.SEARCH_KEY) = $event)),
          onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => {$options.getList('');}, ["enter"]))
        }, null, 544), [
          [_vModelText, $data.api.list.SEARCH_KEY]
        ]),
        _cache[66] || (_cache[66] = _createElementVNode("div", { class: "searchBtn" }, "검색", -1))
      ]),
      _createElementVNode("div", _hoisted_39, [
        _cache[67] || (_cache[67] = _createElementVNode("span", { class: "gmFont bold" }, "선택된 상세조건", -1)),
        _createTextVNode(" : " + _toDisplayString($data.ui.filter_val.SELECT_TXT), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.group_list, (r, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", {
              class: "left",
              style: {"margin-top":"8px"},
              onClick: ($event: any) => ($options.group_detail_check(r, $data.arr.group_cust_list[index]))
            }, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "mgR10",
                    style: {"width":"16px","height":"16px"},
                    "onUpdate:modelValue": ($event: any) => (($data.arr.group_cust_list[index].is_all) = $event),
                    onChange: ($event: any) => {$options.group_check_all($data.arr.group_cust_list[index]);}
                  }, null, 40, _hoisted_44), [
                    [_vModelCheckbox, $data.arr.group_cust_list[index].is_all]
                  ]),
                  _cache[68] || (_cache[68] = _createTextVNode(" 전체선택 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_45, _toDisplayString(r.GROUP_NM) + " (" + _toDisplayString(r.CNT.toComma()) + ")", 1)
            ], 8, _hoisted_42),
            (r.GROUP_NO > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("button", {
                    class: "whiteBtn mgR10",
                    onClick: ($event: any) => ($options.order_update(r.GROUP_NO, 'top'))
                  }, "△ 맨위로", 8, _hoisted_47),
                  _createElementVNode("button", {
                    class: "whiteBtn mgR10",
                    onClick: ($event: any) => ($options.order_update(r.GROUP_NO, 'up'))
                  }, "▲위로", 8, _hoisted_48),
                  _createElementVNode("button", {
                    class: "whiteBtn mgR10",
                    onClick: ($event: any) => ($options.order_update(r.GROUP_NO, 'down'))
                  }, "▼ 아래로", 8, _hoisted_49),
                  _createElementVNode("button", {
                    class: "whiteBtn mgR10",
                    onClick: ($event: any) => ($options.order_update(r.GROUP_NO, 'bottom'))
                  }, "▽ 맨아래로", 8, _hoisted_50),
                  _createElementVNode("button", {
                    class: "blueBtn mgR10",
                    onClick: ($event: any) => ($options.group_edit_layer(r))
                  }, "그룹명 수정 ", 8, _hoisted_51),
                  _createElementVNode("button", {
                    class: "redBtn mgR10",
                    onClick: ($event: any) => ($options.group_del_layer(r))
                  }, "그룹삭제", 8, _hoisted_52)
                ]))
              : _createCommentVNode("", true),
            (r.GROUP_NO < 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _cache[69] || (_cache[69] = _createElementVNode("span", null, [
                    _createTextVNode(" ※ 그룹이 설정되지 않은 연락처는 기본그룹에 포함됩니다."),
                    _createElementVNode("br"),
                    _createTextVNode(" 기본그룹(그룹 미지정)은 수정하실 수 없습니다. ")
                  ], -1)),
                  _createElementVNode("span", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "redBtn",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => {$data.ui.not_group_del_layer=true;})
                    }, "미지정 그룹 비우기")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_55, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.group_cust_list[index].custs, (r2) => {
                return (_openBlock(), _createElementBlock("li", _hoisted_56, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "mgR05",
                      value: r2.CUST_NO,
                      "onUpdate:modelValue": ($event: any) => (($data.arr.group_cust_list[index].cust_nos) = $event)
                    }, null, 8, _hoisted_57), [
                      [_vModelCheckbox, $data.arr.group_cust_list[index].cust_nos]
                    ]),
                    _createTextVNode(_toDisplayString(r2.CUST_NM) + "(" + _toDisplayString(r2.CUST_FMT) + ") ", 1)
                  ])
                ]))
              }), 256))
            ])
          ], 512), [
            [_vShow, $data.arr.group_cust_list[index].is_view]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("button", {
                class: "blueBtn mgR10",
                onClick: ($event: any) => ($options.group_custs_proc('move', r, $data.arr.group_cust_list[index]))
              }, "이동 ", 8, _hoisted_59),
              _createElementVNode("button", {
                class: "yellowBtn mgR10",
                onClick: ($event: any) => ($options.group_custs_proc('copy', r, $data.arr.group_cust_list[index]))
              }, "복사", 8, _hoisted_60)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", {
                class: "blueBtn mgR10",
                onClick: ($event: any) => ($options.group_custs_proc('excl', r, $data.arr.group_cust_list[index]))
              }, "그룹에서 제외 ", 8, _hoisted_62),
              _createElementVNode("button", {
                class: "redBtn mgR10",
                onClick: ($event: any) => ($options.group_custs_proc('del', r, $data.arr.group_cust_list[index]))
              }, "연락처 삭제", 8, _hoisted_63)
            ])
          ], 512), [
            [_vShow, $data.arr.group_cust_list[index].is_view]
          ])
        ]))
      }), 256)),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "groupNameEdit",
                placeholder: "새그룹 추가",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($data.ui.group_nm) = $event)),
                ref: "group_nm",
                maxlength: "50",
                minlength: "2"
              }, null, 512), [
                [_vModelText, $data.ui.group_nm]
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "blueBtn mgR10",
            onClick: _cache[25] || (_cache[25] = ($event: any) => {$options.group_add();})
          }, "추가")
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("button", {
            class: "redBtn left mgR10",
            onClick: _cache[26] || (_cache[26] = ($event: any) => {$data.ui.group_init_layer=true;})
          }, "모든 그룹 리스트 초기화")
        ])
      ])
    ]),
    _createVNode(_component_CustSelectFilter, {
      ref: "CustSelectFilter",
      top: 156,
      left: 661,
      init_filter: $data.ui.filter_val,
      onSetCustSelectFilter: $options.setCustSelectFilter
    }, null, 8, ["init_filter", "onSetCustSelectFilter"])
  ], 64))
}